import { CommonFileType } from '@/types';
import { isImage } from '@/utils';
import { Button } from 'antd';
import React, { FC } from 'react';

import fileIcon from './file_icon.png';

type ImageItemProps = {
  removeFile: (value: string) => void;
  img: CommonFileType;
};

const ImageItem: FC<ImageItemProps> = (props: ImageItemProps) => {
  const { img, removeFile } = props;

  return (
    <div className="image-placeholder">
      <div className="image-content">
        {!isImage(img.name || '') && (
          <img src={fileIcon} className="uploaded-image" alt={img.name} />
        )}
        {isImage(img.name || '') && (
          <img src={img.preview} className="uploaded-image" alt={img.name} />
        )}
        {!isImage(img.name || '') && <span className="uploaded-image-name">{img.name}</span>}
        <Button
          size="small"
          shape="circle"
          className="icon-remove-image"
          onClick={(e) => {
            e.stopPropagation();
            removeFile(img.uniqueId || '');
          }}
        >
          <i className="fa fa-times" />
        </Button>
      </div>
    </div>
  );
};

export default React.memo(ImageItem);
